import DragAndDrop from '../DragNDrop';
import Calendar from 'react-calendar';
import Dropdown from 'react-dropdown';
import styles from './Job.module.css';
import moment from 'moment';

const EditJobView = (props) => {
    const {
        closeEditJob,
        job,
        handleSelectJobType,
        dueDateFormatted,
        toggleShowDueDateCalendar,
        showDueDateCalendar,
        onDueDateChange,
        utilsForDropdown,
        handleSelectUtility,
        handlePacketDrop,
        saveJob,
        canSaveJob,
        isJobDirty,
        hideCalendarFromDocClickIfNeeded,
        handleHospAddress,
        handleHospName,
        handleWorkContactPhone,
        handleSelectForeman,
        foremenForDropdown,
        handleJobPacketUpload,
        job_packet,
        handlePackageFileSelectClick,
        loadingPacket,
        removeWorkPacket
    } = props;

    console.log(canSaveJob);
    //console.log(job ? moment(job.due_date).format('MM/DD/YYYY') : 'job undefined');
    
    return (
        <div
            className={`modal fade show modalContain`}
            id="editJobModal"
            style={{display: "block"}}
            tabIndex="-1"
            aria-modal="true"
            role="dialog"
            aria-labelledby={`editJobModalLabel`}
            aria-hidden="true"
            onClick={(e) => hideCalendarFromDocClickIfNeeded(e)}
          >
            <div
              className={`modal-dialog modalDialog modal-lg modal-dialog-scrollable`}
              role="document"
            >
              <div className={`modal-content modalContent`}>
                {/* <fieldset className="modalFieldset"> */}
    
                  {/* MODAL HEADER */}
                  <div className={`modal-header align-items-center modalHeader`}>
                    <h5
                      className={`modal-title modalTitle`}
                      id={`editJobModalLabel`}
                    >
                      Edit Job
                    </h5>
                    <button
                      type="button"
                      className={`close modalHeaderClose`}
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => props.closeEditJob()}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  
                  {/* MODAL BODY */}
                  <div className={`modal-body modalBody`}>
                    
                    <div className="container-fluid">

                      {/* section - Job */}
                      <div className="row section sectionJob">

                        {/* item - Job Number */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item jobNumber">
                          <label className="labelTitle lg">Job</label>
                          <input
                            type="text"
                            placeholder="Not generated yet"
                            // onChange={this.handleJobNumber}
                            defaultValue={job ? job.job_number : ''}
                            readOnly />
                        </div>
                        
                        {/* item - Job Type */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item jobType">
                          <label className="labelTitle lg">Job Type</label>
                          <div className="d-flex flex-column flex-sm-row radioItems">
                            <input
                              type="radio"
                              className="btn-check"
                              name="jobType"
                              id="jobTypeNormal"
                              defaultValue="normal"
                              defaultChecked={job && job.job_type === 0}
                              readOnly />
                            <label
                              className="btn btn-secondary"
                              htmlFor="jobTypeNormal"
                              onClick={() => handleSelectJobType('normal')}
                            >
                              Normal
                            </label>
                            <input
                              type="radio"
                              className="btn-check"
                              name="jobType"
                              id="jobTypeEstimation"
                              defaultValue="estimation"
                              defaultChecked={job && job.job_type === 1}
                              readOnly />
                            <label
                              className="btn btn-secondary"
                              htmlFor="jobTypeEstimation"
                              onClick={() => handleSelectJobType('estimation')}
                            >
                              Estimation
                            </label>
                          </div>
                        </div>
                        
                        {/* item - Due Date */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item date">
                          <label className="labelTitle lg">Due Date (*)</label>
                          <input
                            type="text"
                            value={job && job.due_date ? job.due_date.format('MM/DD/YYYY') : 'No date setup yet'}
                            onClick={toggleShowDueDateCalendar} 
                            readOnly={true}
                            />
                          <div
                            hidden={!showDueDateCalendar}
                            className="dateCalendar"
                          >
                            <Calendar
                              onChange={onDueDateChange}
                              value={job && job.due_date ? moment(job.due_date).toDate() : new Date()}
                              className={"modal-calendar"} />
                          </div>
                        </div>
                      </div>
                        
                      {/* section - Foreman */}
                      <div className="row section sectionForeman">
                        
                        {/* item - Utility */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item utility">
                          <label className="labelTitle lg">Utility (*)</label>
                          <Dropdown
                            options={utilsForDropdown}
                            onChange={handleSelectUtility}
                            value={job ? job.selected_utility_name : ''}
                            placeholder="Utility is required" />
                        </div>
                        
                        {/* item - Drag & Drop */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item uploadSection">
                          <div style={{position: 'absolute', top: '0', left: '0', width:'100%', height: '100%', display: loadingPacket ? 'block' : 'none', textAlign: 'center', paddingTop: '5px'}}>
                            
                            <div style={{zIndex: '2', position: 'relative'}}>
                              <svg style={{animationName: 'spin', animationDuration: '1000ms', animationIterationCount: 'infinite', animationTimingFunction: 'linear' }} width="50" height="50" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg" ><path fillRule="evenodd" clipRule="evenodd" d="M117.236 117.564L135.488 51.7447C92.1144 58.0338 57.8376 92.408 51.6958 135.829L27.8827 142.432C31.5571 80.9652 80.6763 31.7417 142.099 27.9031L149.836 0L149.836 27.6621V50.7138L149.836 149.836L150 150L182.436 117.564L247.963 135.734C241.785 92.3581 207.526 58.0292 164.185 51.7447L157.574 27.9031C218.965 31.7398 268.066 80.9159 271.784 142.34L300 150.164L150.164 150.164L182.436 182.436L164.279 247.914C207.349 241.626 241.429 207.643 247.863 164.621L271.742 158C267.712 219.081 218.792 267.897 157.666 271.763L149.836 300L149.836 272.01V248.959L149.836 150.491L117.564 182.764L51.7948 164.526C58.1928 207.593 92.292 241.622 135.393 247.914L142.006 271.763C80.8492 267.895 31.9107 219.032 27.9244 157.907L0 150.164L27.6625 150.164H50.7143L149.836 150.164L117.236 117.564Z" fill="#FFCC18"></path></svg>
                            </div>
                            <div style={{background: 'black', opacity: '.2', width: '100%', height: '100%', position: 'absolute', top: '0', left: '0', zIndex: '1'}}></div>
                          </div>
                          <div className={`upload-section ${styles.itemFull}`}>
                            <label className="hide">Drag & Drop Packet of Work PDFs</label>
                            <div style={{display: 'none'}}>
                              <input type="file" ref={job_packet} onChange={(e) => handleJobPacketUpload(e) }/>
                          </div>
                            <DragAndDrop
                              copy="Drag &amp; Drop Packet of Work PDFs"
                              handleDrop={handlePacketDrop}
                              handleFileSelect={handlePackageFileSelectClick}
                              file={job && job.work_packet_name ? {name:job.work_packet_name, url:job.work_packet_url} : {}}
                              removeFiles={removeWorkPacket}
                              type={'workpacket'} />
                              
                          </div>
                        </div>
                      </div>
                        
                      {/* section - Emergency */}
                      <div className="row mb-0 section sectionEmergency">
                        {/* item - Foreman */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item foreman">
                          <label className="labelTitle lg">Foreman</label>
                          <Dropdown
                            key={"One"}
                            options={foremenForDropdown ? foremenForDropdown : []} 
                            onChange={handleSelectForeman} 
                            value={job ? job.foreman_name : ''} 
                            placeholder="Foreman is optional" />
                        </div>
                        
                                                  {/* item - Work Contact Phone */}
                          <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item workContactPhone">
                          <label
                            className="labelTitle lg"
                            htmlFor="workContactPhone"
                          >
                            Work Contact Phone
                          </label>
                          <input
                            type="text"
                            name="workContactPhone"
                            id="workContactPhone"
                            value={job && job.work_contact_phone ? job.work_contact_phone : ''}
                            onChange={(e) => handleWorkContactPhone(e.target.value)} />
                        </div>
                        

                        {/* item - Hospital Name */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item hospitalName">
                          <label
                            className="labelTitle lg"
                            htmlFor="hospName"
                          >
                            Hospital Name
                          </label>
                          <input
                            type="text"
                            name="hospName"
                            id="hospName"
                            value={job && job.hospital_name ? job.hospital_name : ''}
                            onChange={(e) => handleHospName(e.target.value)} />
                        </div>
                        
                        {/* item - Hospital Address */}
                        <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item hospitalAddress">
                          <label
                            className="labelTitle lg"
                            htmlFor="hospAddress"
                          >
                            Hospital Address
                          </label>
                          <input
                            type="text"
                            name="hosAddress"
                            id="hospAddress"
                            value={job && job.hospital_address ? job.hospital_address : ''}
                            onChange={(e) => handleHospAddress(e.target.value)} />
                        </div>
                      </div>
                    </div>
          
                  </div>
                  
                  {/* MODAL FOOTER */}
                  <div className={`modal-footer modalFooter`}>
                     <button
                       type="button"
                       className={`btn btn-secondary modalFooterButton`}
                       data-dismiss="modal"
                       onClick={() => props.closeEditJob()}
                      >
                        Close
                      </button>

                     <button
                      type="button"
                      className={`btn btn-primary modalFooterButton`}
                      onClick={props.saveJob}
                      disabled={!(props.canSaveJob && props.isJobDirty)}
                    >
                     Save
                    </button>
                  </div>
                
                {/* </fieldset> */}
              </div>
            </div>
          </div>
    );
}

export default EditJobView